import { useNavigate } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Stats, WhyEagle, MarqueeStrip } from "../components/Intro";
import { CessnaBand } from "../components/Highlights";
import { PartnerMarquee } from "../components/PartnerMarquee";
import { Programs } from "../components/Programs";
import { Fleet } from "../components/Fleet";
import { Timeline } from "../components/Timeline";
import { Accommodation } from "../components/Accommodation";
import { CTABand } from "../components/CTABand";
import { PROGRAMS } from "../data";

export default function Home({ onApply }) {
  const navigate = useNavigate();
  return (
    <>
      <Hero onApply={onApply} onExplore={() => navigate("/courses")} />
      <Stats />
      <WhyEagle />
      <CessnaBand />
      <PartnerMarquee />
      <Programs items={PROGRAMS.slice(0, 6)} onCardClick={() => navigate("/courses")} cta="Learn More" />
      <MarqueeStrip />
      <Fleet />
      <Timeline />
      <Accommodation />
      <CTABand onApply={onApply} />
    </>
  );
}
